import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EmptyStateComponent } from '@buspro/web/shared';

@Component({
  selector: 'tenant-no-access-page',
  standalone: true,
  imports: [EmptyStateComponent, RouterLink],
  template: `
    <buspro-empty-state
      icon="lock"
      title="You don't have access to this page"
      description="If you need it for your work, ask your administrator."
    >
      <a routerLink="/" class="btn btn-primary btn-sm">Back to home</a>
    </buspro-empty-state>
  `,
})
export class NoAccessPageComponent {}
